import { createQueryKeys } from "@lukemorales/query-key-factory";

import { getTestosteroneSteps } from "./steps";

export const testosteroneQueriesStore = createQueryKeys("testosterone", {
  steps: {
    queryKey: null,
    queryFn: getTestosteroneSteps,
  },
});
